<template>
  <form @submit.prevent="submit" class="hospital-lookup-form">
    <div>
      <h3>Step 1 - Find Your Hospital</h3>
      <rp-select
        v-model="resource.country"
        placeholder="Select Country">
        <option v-for="country in countries"
          :key="country.name"
          :value="country">
          {{country.name}}
        </option>
      </rp-select>
    </div>
    <div v-show="resource.country">
      <div class="hospital-lookup-row">
        <rp-dropdown
          ref="hospitalDropdown"
          v-model="resource.hospital"
          :data-model="hospitalsByCountry"
          :formStyle="true"
          @click.native="onHospitalDropDown"
          scrollable
          objectLabel="displayName"
          placeholder="Search for Hospital"
          tempIdentifier="Hospital" />
        <rp-sprite class="clear-button" name="close" @click.native="onHospitalClear(false)" />
      </div>
      <rp-button v-if="(hospitalsViewed || hospitalsByCountry.length === 0) && !resource.hospital" 
        :type="getButtonType"
        @click="onHospitalNotFound">
        My hospital is not listed!
      </rp-button>
    </div>
    <div v-if="resource.country && resource.hospital">
      <h3>Step 2 - Confirm Your Hospital</h3>
      <div class="hospital-lookup-row">
        <rp-textinput
          v-model="resource.hospital.name"
          placeholder="Hospital Name"
          :disabled="true" />
        <rp-textinput
          v-model="resource.hospital.address_1"
          placeholder="Address Line 1"
          :disabled="true" />
        <rp-textinput
          v-model="resource.hospital.address_2"
          placeholder="Address Line 2"
          :disabled="true" />
      </div>
      <div class="hospital-lookup-row">
        <rp-textinput
          v-model="resource.hospital.town"
          placeholder="Town/City"
          :disabled="true" />
        <rp-textinput
          v-model="resource.hospital.postcode"
          placeholder="Postcode"
          :disabled="true" />
        <rp-textinput
          v-model="resource.country.name"
          placeholder="Country"
          :disabled="true" />
      </div>
      <div class="hospital-lookup-row">
        <rp-button type="primary" @click="onHospitalFound">
          Yes, this is my hospital!
        </rp-button>
        <rp-button type="secondary" @click="onHospitalClear(true)">
          No, this is not my hospital!
        </rp-button>
      </div>
    </div>
  </form>
</template>

<script>
  import form from '../../../mixins/form'
  import Sprite from '../../../components/ui/Sprite'
  import Select from '../../../components/ui/inputs/StyledSelect'
  import Dropdown from '../../../components/ui/inputs/dropdown/Dropdown'
  import TextInput from '../../../components/ui/inputs/TextInput'
  import Button from '../../../components/ui/inputs/Button'

  export default {
    mixins: [form],

    components: {
      'rp-sprite': Sprite,
      'rp-select': Select,
      'rp-dropdown': Dropdown,
      'rp-textinput': TextInput,
      'rp-button': Button,
    },

    props: {
      countries: Array,
      hospitals: Array,
    },

    data() {
      return {
        hospitalsViewed: false,
        highlightNotFound: false,
      }
    },

    computed: {
      hospitalsByCountry() {
        return this.hospitals.reduce((filtered, hospital) => {
          if (hospital.country.id === this.resource.country.id) {
            let hosp = Object.assign({}, hospital)
            hosp['displayName'] = `${hospital.name}, ${hospital.address_1}, ${hospital.town}, ${hospital.postcode}`
            filtered.push(hosp)
          }
          return filtered
        }, [])
      },

      getButtonType() {
        return this.highlightNotFound ? 'primary' : 'secondary'
      },
    },

    methods: {
      onHospitalDropDown() {
        this.hospitalsViewed = true
      },

      onHospitalClear(applyHighlight) {
        this.clearHospital()
        if (applyHighlight) {
          this.highlightNotFound = true
        }
      },

      onHospitalFound() {
        this.$emit('hospitalFound', this.resource.hospital)
      },

      onHospitalNotFound(event) {
        event.preventDefault()
        this.$emit('hospitalNotFound')
      },

      clearHospital() {
        this.resource.hospital = null
        if (this.$refs.hospitalDropdown) {
          this.$refs.hospitalDropdown.clearSearchTerm()
          if (this.$refs.hospitalDropdown.$refs.input) {
            this.$refs.hospitalDropdown.$refs.input.blur()
          }
        }
      },
    },

    watch: {
      'resource.country': function (val) {
        this.clearHospital()
        this.hospitalsViewed = false
        this.highlightNotFound = false

        if (val) {
          if (this.hospitalsByCountry.length === 0 && this.$refs.hospitalDropdown) {
            this.$refs.hospitalDropdown.setSearchTerm("No hospitals found in this country!")
            this.highlightNotFound = true
          }
        }
      },
    },

    validations: {},
  }
</script>

<style lang="sass" scoped>
  .hospital-lookup-form
    padding: 20px

    .hospital-lookup-row
      display: flex
      gap: 20px
      > div
        flex-grow: 1

      .clear-button
        width: 20px
        height: 20px
        align-self: center
        cursor: pointer
        opacity: 0.3
</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/forms/HospitalLookupByCountry.vue